<template>
  <div class="failure">
    <p class="failure_icon"></p>
    <p class="failure_message">Leider konnte der Daylight-Server nicht erreicht werden.</p>
  </div>
</template>

<script>
export default {
  name: 'Failure'
}
</script>

<style lang="scss">
  .failure {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .failure_icon {
    width: 30vw;
    height: 30vh;
    background-image: url($failure_icon);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50% 50%;
  }
  .failure_message {
    font-size: 1.2rem;
    line-height: 140%;
    margin: 0.4rem auto;
  }
</style>
